import config from "@Config/index";
import sendAccessToken from "./sendAccessToken";

const GSI_SCRIPT_URL = "https://accounts.google.com/gsi/client";

// Define a type for notification status
export type GoogleOneTapNotificationStatus = {
  status: "" | "not_displayed" | "skipped" | "dismissed";
  reason?: string;
};

const initializeGSI = (
  nextRoute: any,
  onStatusChange?: (status: GoogleOneTapNotificationStatus) => void,
  nonce?: string,
) => {
  if (window.google?.accounts) {
    window.google.accounts.id.initialize({
      client_id: config.GOOGLE_CLIENT_ID,
      cancel_on_tap_outside: false,
      callback: (response: any) =>
        sendAccessToken({ token: response.credential, type: "google_one_tap", nextRoute }),
      ...(nonce ? { nonce } : {}),
    });

    let notificationStatus: GoogleOneTapNotificationStatus = { status: "" };
    window.google.accounts.id.prompt((notification: any) => {
      if (notification.isNotDisplayed()) {
        notificationStatus = { status: "not_displayed" };
        console.log(notification.getNotDisplayedReason());
      } else if (notification.isSkippedMoment()) {
        notificationStatus = { status: "skipped" };
        console.log(notification.getSkippedReason());
      } else if (notification.isDismissedMoment()) {
        notificationStatus = { status: "dismissed" };
        console.log(notification.getDismissedReason());
      }
      // Call the callback with the updated status
      onStatusChange?.(notificationStatus);
    });
  }
};

const loadGoogleOneTap = (
  nextRoute: any,
  callback?: () => void,
  onStatusChange?: (status: GoogleOneTapNotificationStatus) => void,
  nonce?: string,
) => {
  if (config.IS_CHINA_APP) return;

  // If the Google GSI script is already loaded, just re-initialize and callback
  if (window.google?.accounts) {
    initializeGSI(nextRoute, onStatusChange, nonce);
    callback?.();
    return;
  }

  // Avoid appending duplicate script tags
  const existingScript = document.querySelector(
    `script[src="${GSI_SCRIPT_URL}"]`,
  ) as HTMLScriptElement | null;
  if (existingScript) return;

  const oneTapScript = document.createElement("script");
  oneTapScript.type = "application/javascript";
  oneTapScript.async = true;
  oneTapScript.defer = true;
  oneTapScript.src = GSI_SCRIPT_URL;
  oneTapScript.nonce = nonce;
  oneTapScript.onload = () => {
    initializeGSI(nextRoute, onStatusChange, nonce);
    callback?.();
  };
  document.body.appendChild(oneTapScript);
};

export default loadGoogleOneTap;
